export default __webpack_public_path__ + "static/media/5.8ab72f40.svg";